import { render, staticRenderFns } from "./help-message.vue?vue&type=template&id=2279215c&scoped=true&"
import script from "./help-message.vue?vue&type=script&lang=js&"
export * from "./help-message.vue?vue&type=script&lang=js&"
import style0 from "./help-message.vue?vue&type=style&index=0&id=2279215c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2279215c",
  null
  
)

component.options.__file = "help-message.vue"
export default component.exports